/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompletePathwayDto } from '../../models/complete-pathway-dto';

export interface PathwaysControllerGetActiveCompletePathway$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Patient identifier
 */
  patientId: string;
}

export function pathwaysControllerGetActiveCompletePathway(http: HttpClient, rootUrl: string, params: PathwaysControllerGetActiveCompletePathway$Params, context?: HttpContext): Observable<StrictHttpResponse<CompletePathwayDto>> {
  const rb = new RequestBuilder(rootUrl, pathwaysControllerGetActiveCompletePathway.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompletePathwayDto>;
    })
  );
}

pathwaysControllerGetActiveCompletePathway.PATH = '/thalea-pathways/pathways/active-complete/{tenant}/{patientId}';
